import printJS from 'print-js'
import ReactModal from 'react-modal';
import { Trans } from 'react-i18next';

import '../../App.css';
import Icon from '../Icons/Icon';

const PhotoRequirements = (props) => {
    const padding = 24; // adjust this to your needs
    let height = (530 + padding);
    let heightPx = height + 'px';
    let heightOffset = height / 2;
    let offsetPx = heightOffset + 'px';

    const style = {
      content: {
        border: '0',
        borderRadius: '4px',
        bottom: 'auto',
        height: heightPx,  // set height
        left: '50%',
        padding: '1rem',
        position: 'fixed',
        right: 'auto',
        top: '50%', // start from center
        transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
        width: '80%',
        maxWidth: '40rem'
      }
    };

    return (
        <ReactModal isOpen={props.isOpen} onRequestClose={props.closeModal} style={style} > {/**/}
            <div className="contact-modal-container">
                <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                    <div style={{display: 'flex', flexDirection: 'row', flex: 1, maxHeight: 24}}>
                        <div className="modal-header-icon" style={{flex: 1, justifyContent: 'center'}}>
                        </div>
                        <div className="modal-close-icon" onClick={props.closeModal}>
                            <Icon name="Close" size={20} />
                        </div>
                    </div>
                    <div className="H5">
                        <Trans>Photo Requirements</Trans>
                    </div>
                    <div className="P3" id="terms-text" style={{marginTop: 16}}>
                        <div className="P2Bold">
                            <Trans>File Format</Trans>:
                        </div>
                        <div className="P3" style={{marginBottom: 16}}>
                            <Trans>We accept images in JPEG or PNG only, please ensure that your photo is saved in this format when uploading.</Trans>
                        </div>
                        <div className="P2Bold">
                            <Trans>File Size and Dimensions</Trans>:
                        </div>
                        <div className="P3" style={{marginBottom: 16}}>
                            <Trans i18nKey="photo-reqs-1">All images must be at least 5 MB (megabytes) or larger and set at highest quality settings to produce an acceptable file dimension for submission. The maximum file size you can upload using your web browser is: 10 MB (megabytes). A portrait style image is recommended over a landscape image.</Trans>
                        </div>
                        <div className="P2Bold">
                            <Trans>File Quality</Trans>:
                        </div>
                        <div className="P3" style={{marginBottom: 16}}>
                            <Trans>No scans are allowed. You can either upload an existing photo or take a photo using your cell phone device, tablet or laptop. The photo must be at least 1500x2000 pixels.</Trans>
                        </div>
                        <div className="P2Bold">
                            <Trans>Cropping</Trans>:
                        </div>
                        <div className="P3" style={{marginBottom: 16}}>
                            <Trans>Please note some cropping may occur in order to fit the image in future Subaru social media features.</Trans>
                        </div>
                        <div className="P3Bold">
                            <Trans>Image Content</Trans>:
                        </div>
                        <div className="P3" style={{marginBottom: 16}}>
                            <Trans>The content of the photo must comply with our Terms and Conditions.</Trans>
                        </div>
                    </div>
                    <div className="two-button-container">
                        <div className="contact-modal-cancel-button" onClick={()=>{printJS({printable: 'terms-text', type: 'html', header: 'Terms and Conditions'})}}>
                            <Icon name="Printer" size={20} style={{marginRight: 10}}/>
                            <Trans>Print</Trans>
                        </div>
                        <div className="contact-modal-cancel-button" onClick={props.closeModal} style={{marginRight: 0}}>
                            <Trans>Close</Trans>
                        </div>
                    </div>
                </div>
            </div>
        </ReactModal>
    )
 }

 export default PhotoRequirements;